import { Component, OnInit } from '@angular/core';
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import { Company } from '../../models/Company.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router,ActivatedRoute} from '@angular/router';
import { ProjectFinancialService } from "../../services/projectFinancial.service";
import { ProjectSearch } from "../../models/ProjectSearch.model";
import * as _ from "lodash";
import {NotificationFactory} from "../../shared/factories/notifications/notifications.factory";
import {UserNotificationService} from "../../services/user-notification.service";
import {LocalStorage} from "../../shared/wrappers/LocalStorage";

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

    _id:string;
    user:any;
    notificationList: any;
    userNotificationList: any;
    commonHelper: CommonHelper = new CommonHelper();
    companies: Company[] = new Array<Company>();
    selectedCompany: Company = null;
    projects: any = [];
    projectsByCompany: any = [];
    currentProjectCustomer: any = null;
    addItemCheck = false;
    newListCheck = true;
    loading: boolean;



    constructor(
        private notificationFactory: NotificationFactory,
        private userNotificationService:UserNotificationService,
        private projectFinancialService: ProjectFinancialService,
        public toastr: ToastsManager,
        public localStorage:LocalStorage,
        private route: ActivatedRoute,
        public router: Router
    ) { }

    async ngOnInit() {
        this._id = this.route.snapshot.params['id'];
        this.user = this.localStorage.retrieve("user");

        this.notificationList = this.notificationFactory.generate();
        this.notificationList.user.name = this.user.name;
        this.notificationList.user.username = this.user.username;

        this.userNotificationList = await this.userNotificationService.get(this._id);

        if(!_.isEmpty(this.userNotificationList)){
            this.notificationList = this.userNotificationList[0];
            this.newListCheck = false;
        }


        let projectSearch = new ProjectSearch();
        projectSearch.skip = 0;
        projectSearch.limit = 9999999;

        let response = await this.projectFinancialService.getProjectsAndCustomers();

        this.companies = response.customers;
        this.projects = response.projects;
        this.projectsByCompany = this.projects;

        this.loading = false;
    }

    async createNotificationList() {
        try {
            let response = await this.userNotificationService.create(this.notificationList,this._id);
            this.toastr.success('Lista de notificações criada com sucesso!', "Nova Lista de notificações");
            this.userNotificationList = await this.userNotificationService.get(this._id);
            this.newListCheck = false;
        }catch (err) {
            this.toastr.error("Erro ao criar lista de notificações");

        }

    }

    async addProject() {
        let listItem = {
            company : {
                _id:'',
                name:''
            },
            name:'',
            hashTrackId:''
        };
        this.addItemCheck = true;

        listItem.company._id = this.selectedCompany._id;
        listItem.company.name = this.selectedCompany.name;
        listItem.hashTrackId = this.currentProjectCustomer._id;
        listItem.name = this.currentProjectCustomer.name;

        if(!this.notificationList.list)
            this.notificationList.list = {project:[]};
        this.notificationList.list.project.push(listItem);

        this.selectedCompany = null;
        this.currentProjectCustomer = null;

    }


    async updateNotificationList() {
        try {
            await this.userNotificationService.update(this.notificationList);

            this.toastr.success('Lista de notificações criada com sucesso!', "Nova Lista de notificações");

        }catch (err) {
            console.log(err);
            this.toastr.error("Erro ao criar lista de notificações");

        }

    }

    deleteNotification( i : number) {
        this.notificationList.list.project.splice(i, 1);
        this.addItemCheck = true;
    }

    changeCliente() {
        if (this.selectedCompany)
            this.projectsByCompany = this.projects.filter(x => x.companyId == this.selectedCompany._id);
        else
            this.projectsByCompany = this.projects;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/notifications/notifications.component.ts